class ErrorService {
	constructor() {}
}

const errorService = new ErrorService();

export default errorService;



// WEBPACK FOOTER //
// ./src/core/services/ErrorService.js